"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z",
    id: "path985"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m 9.3101828,4.779661 -0.040007,2 H 21.220339 v 3 H 6.2535421 l -2.0332047,0.00564 v 10.99436 c 0,1.1 0.9,2 2,2 H 21.220337 c 1.1,0 2,-0.9 2,-2 v -14 c 2e-6,-1.1 -0.899998,-2 -1.999998,-2 z m -3.0898438,7 h 3 v 9 h -3 z m 5,0 h 5 v 9 h -5 z m 7,0 h 3 v 9 h -3 z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    transform: "translate(-7.3813484,-7.0144247)",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
      id: "line12",
      y2: "15",
      x2: "15",
      y1: "9",
      x1: "9"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
      id: "line14",
      y2: "15",
      x2: "9",
      y1: "9",
      x1: "15"
    })]
  })]
}));